import { sortByVisibilityCss } from "@/search/Langston/FilterPanel/filters/SortBy/SortBy.styles";
import { FilterSection } from "@/search/Langston/FilterPanel/FilterSection";
import { RadioFilter } from "@/search/Langston/FilterPanel/RadioFilter";

import { LangstonParameterSchema } from "@/search/Langston/LangstonParameterSchema";

const sortByFilterOptions = LangstonParameterSchema.sort.values;

export const SortBy = () => {
  return (
    <div css={sortByVisibilityCss}>
      <FilterSection title="Sort By" defaultCollapsed={false}>
        <RadioFilter
          options={sortByFilterOptions}
          paramName={LangstonParameterSchema.sort.key}
        />
      </FilterSection>
    </div>
  );
};
